import { useMutation } from "@tanstack/react-query";
import { businessCardApi } from "../../../../../services/company-office/BusinessCard.service";

interface IUpdateBCVariable {
  id: string;
  body: any;
}

export const useBCUpdate = () => {
  return useMutation({
    mutationFn: ({ id, body }: IUpdateBCVariable) => {
      const updatedRequest = businessCardApi.toRequest(body);
      return businessCardApi.update(id, updatedRequest);
    },
  });
};
